import { CreditBalance } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'

/** Equivalent of legacy `PaymentCreditViewComponent`. */
export function PaymentCreditPage() {
  return (
    <div>
      <h1>Credit balance</h1>
      <CreditBalance payment={paymentClient} className="screener-card" />
    </div>
  )
}
